define.alias("shared/components/shared/wizard/cancel-button", "media/components/shared/wizard/cancel-button");